import React from 'react';
import { SvgIcon } from '@mui/material';
import duotone from 'icons/duotone';

// Same AssignmentReturn shape, but uses currentColor so active sidebar green applies
const ASSIGNMENT_RETURN_PATH =
  "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z";

const ReturnCancelRequestIcon = (props) => {
  const { sx, ...rest } = props;
  return React.createElement(
    SvgIcon,
    {
      ...rest,
      viewBox: "0 0 24 24",
      sx: [
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        {
          fill: "currentColor",
          "& path": { fill: "currentColor" },
        },
      ],
    },
    React.createElement("path", { d: ASSIGNMENT_RETURN_PATH })
  );
};

// Export navigation items structure for use in other components
export const getAllNavigationItems = (userRole = '', districtCount = '0') => {
  return [
    {
      name: 'Dashboard',
      path: '/dashboard/analytics',
      icon: duotone.Dashboard,
      // badge: {
      //   value: districtCount
      // },
      permission: 'dashboard',
      component: 'Analytics', // Add component identifier
      subTabs: []
    },
    {
      name: 'App Order',
      icon: duotone.DataTable,
      path: '/dashboard/orders-management',
      permission: 'appOrders',
      component: 'OrdersManagement',
      subTabs: []
    },
    {
      name: 'Agronomist',
      icon: duotone.PersonChalkboard,
      path: '/dashboard/agronomist',
      permission: 'talkToAgronomist',
      component: 'Agronomist',
      subTabs: []
    },
    {
      name: 'Bulk Order',
      icon: duotone.LayerGroup,
      path: '/dashboard/bulk-upload',
      permission: 'bulkOrders',
      component: 'BulkUpload',
      subTabs: []
    },
    {
      name: 'Return & Cancel Request',
      icon: ReturnCancelRequestIcon,
      path: '/dashboard/return-cancel-request',
      permission: 'returnCancelRequest',
      component: 'ReturnCancelRequest',
      subTabs: []
    },
    {
      name: 'Quotation',
      icon: duotone.FileCircleQuotation,
      path: '/dashboard/Quotation-proforma',
      permission: 'quotation',
      component: 'QuotationProforma',
      subTabs: []
    },
    {
      name: 'Farmers',
      icon: duotone.UserList,
      path: '/dashboard/farmers',
      permission: 'farmerManagement',
      component: 'Farmers',
      subTabs: []
    },
    {
      name: 'Agri-store',
      icon: duotone.Ecommerce,
      path: '/dashboard/products-management',
      permission: 'agriStore',
      component: 'ProductsManagement',
      subTabs: []
    },
    {
      name: 'Translated Content',
      icon: duotone.ElementHub,
      path: '/dashboard/groceries',
      permission: 'groceries',
      component: 'Groceries',
      subTabs: []
    },
    {
      name: 'Posts',
      icon: duotone.Chat,
      path: '/dashboard/posts',
      permission: 'farmerForum',
      component: 'Posts',
      subTabs: []
    },
    {
      name: 'Knowledge Hub ',
      icon: duotone.Pages,
      path: '/dashboard/courses',
      permission: 'successStories',
      component: 'Courses',
      subTabs: []
    },
    {
      name: 'Event Types',
      icon: duotone.Calender,
      path: '/dashboard/event-types',
      permission: 'eventType',
      component: 'EventTypes',
      subTabs: []
    },
    {
      name: 'Crop Types',
      icon: duotone.DiagramProject,
      path: '/dashboard/crop-types',
      permission: 'cropType',
      component: 'CropTypes',
      subTabs: []
    },
    {
      name: 'Enquiry Form',
      icon: duotone.FileCircleQuestion,
      path: '/dashboard/enquiry-form',
      permission: 'enquiry',
      component: 'EnquiryForm',
      subTabs: []
    },
    {
      name: 'Field Visit',
      icon: duotone.PersonCircleCheck,
      path: '/dashboard/field-visit',
      permission: 'fieldVisit',
      component: 'FieldVisit',
      subTabs: []
    },
    {
      name: 'Category',
      icon: duotone.Invoice,
      path: '/dashboard/invoice',
      permission: 'category',
      component: 'Invoice',
      subTabs: []
    },
    {
      name: 'Crop Hub',
      icon: duotone.Plant,
      path: '/dashboard/crop-hub',
      permission: 'cropHub',
      component: 'CropHub',
      subTabs: []
    },
    {
      name: 'Disease Advisory',
      icon: duotone.CommentsQuestionCheck,
      path: '/dashboard/disease-advisory',
      permission: 'diseaseAdvisory',
      component: 'DiseaseAdvisory',
      subTabs: []
    },
    {
      name: 'AI Chat Bot',
      icon: duotone.Chat,
      path: '/dashboard/ai-chat-bot',
      permission: 'aiChatBot',
      component: 'AIChatBot',
      subTabs: []
    },
    {
      name: 'Users',
      icon: duotone.Accounts,
      path: '/dashboard/users',
      permission: 'users',
      component: 'Users',
      subTabs: []
    },
    {
      name: 'Permissions',
      icon: duotone.TodoList,
      path: '/dashboard/permissions',
      permission: 'permissions',
      component: 'Permissions',
      subTabs: []
    },
    {
      name: 'FAQs',
      icon: duotone.FileCircleQuotation,
      path: '/dashboard/FAQ',
      permission: 'FAQs',
      component: 'FAQs',
      subTabs: []
    },
    {
      name: 'Report',
      icon: duotone.Invoice,
      path: '/dashboard/report',
      permission: 'report',
      component: 'Report',
      subTabs: []
    },
    {
      name: 'Support Feature',
      icon: duotone.CommentsQuestionCheck,
      path: '/dashboard/support',
      permission: 'support',
      component: 'Support',
      subTabs: []
    },
    {
      name: 'Transaction',
      icon: duotone.MessagesDollar,
      path: '/dashboard/transaction',
      permission: 'transaction',
      component: 'Transaction',
      subTabs: []
    }
  ];
};

/** Same allow-checks previously used for disable state — now used to hide unauthorized tabs. */
const isNavPermissionAllowed = (permissions, nav) => {
  if (nav.permission === 'dashboard') {
    return (
      permissions.dashboard?.allowed === true ||
      permissions.dashboard === true ||
      permissions.analytics?.allowed === true ||
      permissions.analytics === true
    );
  }
  if (nav.permission === 'category') {
    return permissions.category?.allowed === true || permissions.category === true;
  }
  if (nav.permission === 'FAQs') {
    return (
      permissions.FAQs?.allowed === true ||
      permissions.faq?.allowed === true ||
      permissions.FAQ?.allowed === true ||
      permissions.FAQs === true ||
      permissions.faq === true ||
      permissions.FAQ === true
    );
  }
  if (nav.permission === 'transaction') {
    const p = permissions.transaction;
    if (p === true) return true;
    if (p && typeof p === 'object' && p.allowed === true) return true;
    return false;
  }

  const p = permissions[nav.permission];
  if (p === true) return true;
  if (p && typeof p === 'object' && p.allowed === true) return true;
  return false;
};

/**
 * Show only authorized tabs in the sidebar. Unauthorized tabs are hidden.
 */
const mapNavWithAccess = (navs, { allEnabled = false, permissions = {} } = {}) =>
  navs
    .filter((nav) => allEnabled || isNavPermissionAllowed(permissions, nav))
    .map((nav) => ({
      ...nav,
      subTabs: [],
      disabled: false,
    }));

const CMD_DASHBOARD_NAV = {
  name: "CMD Dashboard",
  path: "/dashboard/analytics/cmd",
  icon: duotone.Dashboard,
  permission: "dashboard",
  component: "NewDashboard",
  subTabs: [],
  disabled: false,
};

/** Co-Admin: CMD only. Admin and others: existing Dashboard tab only (CMD via URL for Admin). */
const applyDashboardVisibilityByRole = (navs, userRole) => {
  if (userRole === "co_admin") {
    return navs.map((nav) =>
      nav.path === "/dashboard/analytics"
        ? { ...nav, ...CMD_DASHBOARD_NAV }
        : nav
    );
  }

  return navs;
};

// Main function to get navigations based on user permissions
export const getNavigations = () => {
  try {
    const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
    const userRole = loggedData?.data?.user_type || '';
    const permissions = loggedData?.data?.permissions || {};
    
    const allNavigations = getAllNavigationItems(userRole, '0');
    const hasPermissionConfig = permissions && Object.keys(permissions).length > 0;

    // Admin/co_admin: show only tabs with assigned permission.
    if (userRole === 'Admin' || userRole === 'co_admin') {
      if (hasPermissionConfig) {
        const filtered = allNavigations
          .filter((nav) => {
            // Transaction still requires an explicit grant
            if (nav.permission === 'transaction') {
              return isNavPermissionAllowed(permissions, nav);
            }

            const p = permissions[nav.permission];
            // Explicitly denied
            if (p === false) return false;
            if (p && typeof p === 'object' && p.allowed === false) return false;
            // Explicitly allowed
            if (p === true) return true;
            if (p && typeof p === 'object' && p.allowed === true) return true;
            // Not configured yet (newly added modules like Support) → show for Admin/co_admin
            if (p === undefined || p === null) return true;
            return false;
          })
          .map((nav) => ({
            ...nav,
            subTabs: [],
            disabled: false,
          }));
        return applyDashboardVisibilityByRole(filtered, userRole);
      }
      // No permissions object: show all tabs except Transaction (must be explicitly granted)
      const filtered = allNavigations
        .filter((nav) => nav.permission !== 'transaction')
        .map((nav) => ({
          ...nav,
          subTabs: [],
          disabled: false,
        }));
      return applyDashboardVisibilityByRole(filtered, userRole);
    }

    // Permission-based users: show only tabs with access
    if (hasPermissionConfig) {
      return applyDashboardVisibilityByRole(
        mapNavWithAccess(allNavigations, { permissions }),
        userRole
      );
    }
    
    // Fallback for roles without a permissions object
    if (userRole === 'Company') {
      return applyDashboardVisibilityByRole(
        mapNavWithAccess(allNavigations, { allEnabled: true }),
        userRole
      );
    } else if (userRole === 'chapter_admin') {
      return applyDashboardVisibilityByRole(
        [
          { ...allNavigations[0], subTabs: [], disabled: false },
          { ...allNavigations[1], subTabs: [], disabled: false },
        ],
        userRole
      );
    }

    return [];
  } catch (error) {
    console.error('Error getting navigations:', error);
    return [];
  }
};

export const navigations = getNavigations();
export const refreshNavigations = () => getNavigations();